// extracted by mini-css-extract-plugin
export default {"container":"login_form_container__isHBU","content":"login_form_content__gJo4Z","tenant_logo":"login_form_tenant_logo__uCiSJ"};